module.exports = __webpack_public_path__ + "img/mySupporter.17d6c471.png";